import managerLaunchStatusService from './managerLaunchStatusService';

import type { ManagerLaunchStatus } from '@/types/cycle-evaluation/ManagerLaunchStatus';

import { CycleEvaluationQueryKey } from '@/constants/QueryKeys';
import { useAmelioPaginatedQuery } from '@/hooks/api/useAmelioPaginatedQuery';

const useGetManagerLaunchStatusPaged = ({
    sentCycleId,
    isLaunched,
    pageNumber,
    pageSize,
}: {
    sentCycleId: string;
    isLaunched: boolean;
    pageNumber: number;
    pageSize: number;
}) => {
    return useAmelioPaginatedQuery<ManagerLaunchStatus>({
        queryKey: [CycleEvaluationQueryKey.MANAGER_LAUNCH_STATUS, sentCycleId, isLaunched],
        queryFn: managerLaunchStatusService.getManagerLaunchStatus,
        pageNumber,
        pageSize,
        meta: { sentCycleId, isLaunched },
        options: {
            enabled: !!sentCycleId && isLaunched !== undefined && isLaunched !== null,
        },
    });
};

export { useGetManagerLaunchStatusPaged };
